import React from 'react';
import { withRouter } from "react-router-dom";
import FormsAndDocumentComponent from './formsAndDocumentComponent';


const FormsAndDocumentsLanding = (props) => {
    return <FormsAndDocumentComponent/>
}
export default withRouter(FormsAndDocumentsLanding);